import React, { useState, useEffect } from "react";
import { FaShareAlt } from "react-icons/fa";
import ShareModal from "../ShareModal/ShareModal";
import { trackLandingVisitApi } from "../../utils/shareTracking";
import "./ShareProjectButton.css";

const ShareProjectButton = ({ project }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Auto-resolve project details if only partial info is passed
  const resolvedProject = {
    id: project?.id || project?.docId || "project",
    title: project?.title || project?.name || document.title.split("|")[0].trim() || "Project",
    path: project?.path || project?.link || (typeof window !== "undefined" ? window.location.pathname : ""),
    category: project?.category || "Software Applications"
  };

  // Track campaign landing visit on page load if UTM query parameters exist
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.search) {
      trackLandingVisitApi({
        projectId: resolvedProject.id,
        projectTitle: resolvedProject.title,
        projectPath: resolvedProject.path
      });
    }
  }, [resolvedProject.id, resolvedProject.title, resolvedProject.path]);

  return (
    <>
      <button
        type="button"
        className="visit-project-button share-project-btn"
        onClick={() => setIsModalOpen(true)}
        aria-label={`Share ${resolvedProject.title}`}
        title="Share Project with Tracking Links"
      >
        <span className="share-btn-icon">
          <FaShareAlt />
        </span>
        <span className="share-btn-text">Share Project</span>
      </button>

      <ShareModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        project={resolvedProject}
      />
    </>
  );
};

export default ShareProjectButton;
